import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
/**
 * @hidden
 */
var KendoButtonService = /** @class */ (function () {
    function KendoButtonService() {
        this.buttonLookChange = new BehaviorSubject('default');
        this.buttonClicked = new Subject();
        this.buttonClicked$ = this.buttonClicked.asObservable();
    }
    KendoButtonService.prototype.click = function (button) {
        this.buttonClicked.next(button);
    };
    KendoButtonService.prototype.setButtonLook = function (look) {
        this.buttonLookChange.next(look);
    };
    KendoButtonService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    KendoButtonService.ctorParameters = function () { return []; };
    return KendoButtonService;
}());
export { KendoButtonService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-toolbar/node_modules/@progress/kendo-angular-buttons/dist/es/button/button.service.js
// module id = ../../../../@progress/kendo-angular-toolbar/node_modules/@progress/kendo-angular-buttons/dist/es/button/button.service.js
// module chunks = vendor